import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e60be9c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "dropdown-items-wrapper" };
const _hoisted_2 = {
    key: 0,
    class: "header"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_click_outside = _resolveDirective("click-outside");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.header)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.header), 1))
            : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])), [
        [_directive_click_outside, _ctx.close]
    ]);
}
